import React from 'react'
import { DropzoneRootProps } from 'react-dropzone'

// Passes a drag to dropzone only when it carries files and its target is in
// the composer's own DOM. Without this, dropzone cancels text drags into the
// textarea, and drops on the paperclip modal (a React child rendered through a
// portal) bubble up here and attach before "Add to Chat".
export const ownFileDragsOnly = (
  rootProps: DropzoneRootProps,
): DropzoneRootProps => {
  const guard =
    (handler?: React.DragEventHandler<HTMLElement>) =>
    (e: React.DragEvent<HTMLElement>): void => {
      if (
        e.dataTransfer.types.includes('Files') &&
        e.currentTarget.contains(e.target as Node)
      ) {
        handler?.(e)
      }
    }
  return {
    ...rootProps,
    onDragEnter: guard(rootProps.onDragEnter),
    onDragOver: guard(rootProps.onDragOver),
    onDragLeave: guard(rootProps.onDragLeave),
    onDrop: guard(rootProps.onDrop),
  }
}
